export default {
  methods: {
    shareLink(subject, message, url) {
      const options = {
        subject,
        message: `${message}\n${url}`
      };

      window.plugins.socialsharing.shareWithOptions(options);
    },
    shareCurrentLink(subject, message) {
      const url = process.env.VUE_APP_URL + this.$route.fullPath;
      this.shareLink(subject, message, url);
    }
  }
};
